import type { GiantId } from '../../../domain/ids/ids';
import {
  deliveryDialogContentForGiant,
  type DeliveryDialogContent,
} from '../shared/deliveryDialogContent';

export type NewDeliveryScreenProps = {
  giantId: GiantId;
  orderIndex?: number;
  /** Reveal real item image (replay from delivery list). */
  revealItem?: boolean;
  /** When false, take-order CTA is disabled (e.g. not enough passes for replay). */
  canTakeOrder?: boolean;
  levelNameText?: string;
  giantNameText?: string;
  riddleText?: string;
  deliveryItemText?: string;
  answerText?: string;
  onGoBack?: () => void;
  onTakeOrder?: () => void;
};

export type NewDeliveryScreenModel = {
  giantId: GiantId;
  orderIndex: number;
  revealItem: boolean;
  canTakeOrder: boolean;
  levelNameText: string;
  giantNameText: string;
  riddleText: string;
  deliveryItemText: string;
  answerText: string;
  onGoBack?: () => void;
  onTakeOrder?: () => void;
};

export function createNewDeliveryScreenModel(
  props: NewDeliveryScreenProps,
): NewDeliveryScreenModel {
  const orderIndex = props.orderIndex ?? 0;
  const content: DeliveryDialogContent = deliveryDialogContentForGiant(
    props.giantId,
    orderIndex,
  );

  return {
    giantId: props.giantId,
    orderIndex,
    revealItem: props.revealItem === true,
    canTakeOrder: props.canTakeOrder !== false,
    levelNameText: props.levelNameText ?? content.levelNameText,
    giantNameText: props.giantNameText ?? content.giantNameText,
    riddleText: props.riddleText ?? content.riddleText,
    deliveryItemText: props.deliveryItemText ?? content.deliveryItemText,
    answerText: props.answerText ?? content.answerText,
    onGoBack: props.onGoBack,
    onTakeOrder: props.onTakeOrder,
  };
}
